import { DecimalPipe, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputErrorComponent } from '@common/components/input/input-error/input-error.component';
import { InputLabelComponent } from '@common/components/input/input-label/input-label.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { BaseInputComponent } from '../base-input/base-input.component';
import { NumberInputConfig } from '../input.type';

/**
 * Number input component.
 * @param min - The minimum number.
 * @param max - The maximum number.
 * @param format - The format of the number.
 * @param decimals - The number of decimals.
 * @param maxLength - The maximum length of the number.
 * @param showSpinners - Whether to show spinners(Up and Down arrows) in edit mode.
 */
@Component({
    selector: 'app-number-input',
    templateUrl: './number-input.component.html',
    providers: [{ provide: BaseInputComponent, useExisting: NumberInputComponent }],
    imports: [
        InputLabelComponent,
        NumericTextBoxComponent,
        TranslatePipe,
        NgClass,
        InputErrorComponent,
        FormsModule,
        TooltipDirective,
        DecimalPipe
    ]
})
export class NumberInputComponent extends BaseInputComponent<number> implements OnInit {
    @Input() min: NumberInputConfig['min'] = 0;
    @Input() max: NumberInputConfig['max'];
    @Input() format: NumberInputConfig['format'] = '#';
    @Input() decimals: NumberInputConfig['decimals'] = 2;
    @Input() maxLength: NumberInputConfig['maxLength'];
    @Input() showSpinners: NumberInputConfig['showSpinners'] = false;

    viewNumberFormat: string;
    ngOnInit(): void {
        // have to check for undefined as 0 is a valid number
        if (this.decimals !== undefined) {
            this.format = `n${this.decimals}`;
            this.viewNumberFormat = `1.${this.decimals}-${this.decimals}`;
        }
    }
    onInput(event: any): void {
        if (this.maxLength) {
            const value = event.target.value;
            const [intPart, decPart] = value.split(',');
            if (intPart.length > this.maxLength) {
                const newValue = `${intPart.slice(0, this.maxLength)}${value.includes(',') ? `,${decPart}` : ''}`;
                event.target.value = newValue;
            }
        }
    }
}
